import { render } from "./BaseAmountTitle.vue?vue&type=template&id=435fe576&scoped=true"
import script from "./BaseAmountTitle.vue?vue&type=script&lang=js"
export * from "./BaseAmountTitle.vue?vue&type=script&lang=js"

import "./BaseAmountTitle.vue?vue&type=style&index=0&id=435fe576&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435fe576"],['__file',"src/components/helpers/BaseAmountTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "435fe576"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('435fe576', __exports__)) {
    console.log('reload')
    api.reload('435fe576', __exports__)
  }
  
  module.hot.accept("./BaseAmountTitle.vue?vue&type=template&id=435fe576&scoped=true", () => {
    console.log('re-render')
    api.rerender('435fe576', render)
  })

}


export default __exports__